import { variables } from './variables';

export const theme = {
  spacing: {
    xs   : variables.spacing.xs,
    sm   : variables.spacing.sm,
    md   : variables.spacing.md,
    lg   : variables.spacing.lg,
    xl   : variables.spacing.xl,
    xxl  : variables.spacing.xxl,
    xxxl : variables.spacing.xxxl,
  },
  textColor: {
    primary   : variables.colors.primary,
    secondary : variables.colors.secondary,
    white     : variables.colors.white,
    black     : variables.colors.black,
    gray      : variables.colors.gray,
    darkGray  : variables.colors.darkGray,
    lightGray : variables.colors.lightGray,
    blue      : variables.colors.blue,
    red       : variables.colors.red,
    darkRed   : variables.colors.darkRed,
    lightRed  : variables.colors.lightRed,
    green     : variables.colors.green,
  },
  backgroundColor: {
    white     : variables.colors.white,
    blue      : variables.colors.blue,
    darkBlue  : variables.colors.secondary,
    lightBlue : variables.colors.lightBlue,
    gray      : '#AEAEAE',
    lightGray : variables.colors.lightGray,
    red       : variables.colors.red,
  },
  borderColor: {
    primary   : variables.colors.primary,
    secondary : variables.colors.secondary,
    blue      : variables.colors.blue,
    lightBlue : variables.colors.lightBlue,
    lightGray : '#DDDDDD',
  },
  maxWidthMobile: 960,
};
